import { Typography, Box, Grid } from "@mui/material";
import { useTheme, useMediaQuery } from '@mui/material';

const CONTACT_EMAIL = 'support-cliqloan@amitasoft.com';
const CONTACT_PHONE = '+1-408-430-3650';

const contactLinkStyle = {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'justify',
    color: '#31B9B5',
    textDecoration: 'none',
    display: 'block',
};

const ContactUs = () => {

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid container justifyContent="center" spacing={2}> {/* Center align with spacing */}
            <Grid item xs={11} md={11} lg={11} mt={2} mb={2} ml={2} mr={2}> {/* Apply margins here */}
                <div>
                    <Box mt={2} mb={2}>
                        {/* <Typography variant="h1" style={{ fontWeight: 700, fontSize: '32px', lineHeight: '48px' }}>
                            Have questions? We are here to help.
                        </Typography> */}
                        <Typography
                            variant="h1"
                            style={{
                                fontWeight: 700,
                                fontSize: '32px',
                                lineHeight: '48px',
                                display: isSmallScreen ? 'block' : 'inline'
                            }}
                        >
                            Have questions? {isSmallScreen && <br />} We are here to help.
                        </Typography>

                    </Box>

                    <Box mb={2}>
                        <Typography variant="body1" style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', textAlign: 'justify' }}>
                            Email us:
                        </Typography>
                        <Typography
                            component="a"
                            href={`mailto:${CONTACT_EMAIL}`}
                            variant="body1"
                            style={contactLinkStyle}
                        >
                            {CONTACT_EMAIL}
                        </Typography>
                    </Box>
                    <Box mb={2}>
                        <Typography variant="body1" style={{ fontWeight: 400, fontSize: '16px', lineHeight: '24px', textAlign: 'justify' }}>
                            Call us:
                        </Typography>
                        <Typography
                            component="a"
                            href={`tel:${CONTACT_PHONE}`}
                            variant="body1"
                            style={contactLinkStyle}
                        >
                            {CONTACT_PHONE}
                        </Typography>
                    </Box>
                </div>
            </Grid>
        </Grid>
    );
};

export default ContactUs;
